import {useState} from 'react';

export const useDebug = () => {
    const isDebug = new URLSearchParams(window.location.search).get('debug') === 'true';
    const [debugStatus, setDebugStatus] = useState<string[]>([]);

    return {isDebug, debugStatus, setDebugStatus};
};
